<template>
    <div class="editor-dropdown">
        <button type="button" @click="toggle" :title="title" class="editor-dropdown-trigger">
            <i v-if="icon" :class="icon" />
            {{ label }}
            <i class="fas fa-caret-down"></i>
        </button>
        <ul v-if="open" class="editor-dropdown-menu">
            <li v-for="item in items" :key="item.label" :class="{ active: item.active }" @click="select(item)">
                {{ item.label }}
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
    import { ref } from "vue";

    export interface DropdownItem {
        label: string;
        active: boolean;
        command: () => void;
    }

    defineProps<{
        title: string;
        icon?: string;
        label: string;
        items: DropdownItem[];
    }>();

    const emit = defineEmits(["select"]);

    const open = ref(false);

    function toggle() {
        open.value = !open.value;
    }

    function select(item: DropdownItem) {
        open.value = false;
        item.command();
        emit("select", item);
    }
</script>

<style scoped lang="scss">
    .editor-dropdown {
        position: relative;

        .editor-dropdown-trigger {
            display: flex;
            align-items: center;
            gap: 0.3rem;
            padding: 0.3rem 0.5rem;
            border: 1px solid #ccc;
            background: white;
            border-radius: 0.3rem;
            cursor: pointer;
        }

        .editor-dropdown-menu {
            position: absolute;
            top: 110%;
            left: 0;
            background: white;
            border: 1px solid #ccc;
            border-radius: 0.3rem;
            z-index: 10;
            min-width: 140px;
            list-style: none;
            padding: 0.3rem 0;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

            li {
                padding: 0.4rem 0.8rem;
                cursor: pointer;

                &.active {
                    background-color: #eee;
                    font-weight: bold;
                }

                &:hover {
                    background-color: #f5f5f5;
                }
            }
        }
    }
</style>
